/**
 * Format time in seconds to human-readable format
 * @param seconds - Time in seconds
 * @returns Formatted string like "5 minutes and 30 seconds" or "45 seconds"
 */
export function formatGameTime(seconds: number): string {
	const minutes = Math.floor(seconds / 60);
	const secs = seconds % 60;

	const formatUnit = (amount: number, unit: 'minute' | 'second') => `${amount} ${unit}${amount === 1 ? '' : 's'}`;

	const secondsLabel = formatUnit(secs, 'second');
	return minutes > 0 ? `${formatUnit(minutes, 'minute')} and ${secondsLabel}` : secondsLabel;
}
